import { Box, Button, Typography } from '@mui/material'
import { Link } from 'react-router-dom'

const NotFound = () => (
  <Box sx={{ flexGrow: 1, display: 'grid', placeItems: 'center', px: 3, py: 8 }}>
    <Box sx={{ textAlign: 'center', maxWidth: 420 }}>
      <Typography variant='overline' color='text.secondary'>
        404
      </Typography>
      <Typography variant='h3' sx={{ mb: 1.5 }}>
        This page does not exist
      </Typography>
      <Typography color='text.secondary' sx={{ mb: 4 }}>
        The link may be out of date, or the board was deleted.
      </Typography>
      <Button component={Link} to='/boards' variant='contained'>
        Back to your boards
      </Button>
    </Box>
  </Box>
)

export default NotFound
